import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <>

    <div className='topo'>
      <div className='info'>Informações de uso do APP</div>     
      </div>

      <div className='deta'>
        O aplicativo não retém nenhuma informação do usuário.
        Toda e qualquer ação executada ou conteúdo publicado pelo usuário durante o uso do aplicativo será de sua exclusiva
        e integral responsabilidade, devendo isentar e indenizar o APP de quaisquer
        reclamações, prejuízos, perdas e danos causados ao APP, em decorrência de tais ações ou manifestações.
      </div>
      
      </>
  );
}

export default App;
